<template>
  <div :class="['user-status', 'user-status--' + statusToTagType()]">
    {{ statusToTagText() }}
  </div>
</template>
<script>
  import {USER_STATUS_ACTIVE, USER_STATUS_CLOSED} from '@/constants';
  export default {
    props: {
      status: {
        type: String,
        default: 'closed'
      }
    },
    methods: {
      statusToTagType (status) {
        switch (this.status) {
          case USER_STATUS_ACTIVE:
            return 'success';
          case USER_STATUS_CLOSED:
            return 'warning';
          default:
            return '';
        }
      },
      statusToTagText (status) {
        switch (this.status) {
          case USER_STATUS_ACTIVE:
            return this.$t('labels.status_active');
          case USER_STATUS_CLOSED:
            return this.$t('labels.status_closed');
          default:
            return this.$t('labels.unknown');
        }
      }
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';

.user-status {
  display: inline-block;
  position: relative;
  line-height: 1;
  white-space: nowrap;
  border: 1px solid;
  color: $secondary-font-color;
  -webkit-appearance: none;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  padding: 8px 12px 8px 24px;
  font-size: 12px;
  border-radius: 4px;
  cursor: default;

  &:before {
    content: '';
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: $secondary-font-color;
    width: 6px;
    height: 6px;
    border-radius: 100%;
  }

  &--warning {
    color: #F25556;

    &:before {
      background: #F25556;
    }
  }

  &--success {
    color: #52B12D;

    &:before {
      background: #52B12D;
    }
  }
}
</style>